import styled from 'styled-components';
import {Row} from '../../../../../../stories/components/hotels/common/Layouts/Layouts';

export const PayModePersuasionContainer = styled.div(
  props => `
  padding:0;
  display: flex;
  align-items: flex-start;
`,
);

export const PayModePersuasionTextsContainer = styled.div(
  props => `
  // padding: ${props.theme.spacing.small} 0 0 ${props.theme.spacing.small};
  padding-left: 1rem;
`,
);

export const PayModePersuasionTextContainer = styled.div(
  props => `
  // padding: ${props.theme.spacing.small} 0 ${props.theme.spacing.base} 0;

  display: flex;
  align-items: center;

`,
);

export const PayModePersuasionCardTextContainer = styled.div(
  props => `
  // padding: ${props.theme.spacing.small} 0 ${props.theme.spacing.base} 0;

  display: flex;
  align-items: center;
  color: ${props.theme.colors.goGreen.base};
  margin-top: ${props.theme.spacing.small};
`,
);

export const TaxesTextStyled = styled(Row)(
  props => `
  font-size: 12px;
  color: ${props.theme.colors.goGreen.base};

`,
);

export const PayAtHotelTaxesText = styled.span(
  props => `
  padding: 0 ${props.theme.spacing.xsmall} 0 0;
`,
);
